<div class="on-lab-req">
    <div style="display: flex">
        <div class="patient-info">
            <img src="assets/libs/ui/lab-req/ontario-lab.png" alt="ontario-img" class="logo" />

            <div>
                <p class="label">Name</p>
                <div class="input">
                    {{adminUser?.firstName + ' ' + adminUser?.lastName}} {{adminUser?.credential || 'NP'}}
                </div>
            </div>
            <div>
                <p class="label">Address</p>
                <div class="input">
                    2620 Bristol Circle Unit 400<br />
                    Oakville ON L6H 6Z7<br />
                    289-401-4678 EXT 1125 FAX 1-855-952-2436<br />
                    FAX 1-855-952-2436
                </div>
            </div>
            <div nz-row>
                <div nz-col nzSpan="14">
                    <p class="label">Clinician/Practitioner Number</p>
                    <div class="input">
                        {{selectedLicense?.onId || ''}}
                    </div>
                </div>
                <div nz-col nzSpan="10">
                    <p class="label">CPSO / Registration No.</p>
                    <div class="input">
                        {{selectedLicense?.number || ''}}
                    </div>
                </div>
            </div>
            <div>
                <p class="label">Check one:</p>
                <div class="insurance-type">
                    <nz-form-item *ngFor="let option of insuranceTypeOptions;">
                        <nz-form-control style="max-width: 24px">
                            <label [id]="'insuranceType_' + option.value" class="check" nz-checkbox nzDisabled
                                [ngModel]="values['insuranceType_' + option.value]"></label>
                        </nz-form-control>
                        <nz-form-label class="input-label" [nzNoColon]="true"
                            [nzFor]="'insuranceType_' + option.value">{{option.label}}</nz-form-label>
                    </nz-form-item>
                </div>
            </div>
            <div>
                <p class="label">
                    Additional Clinical Information (e.g. diagnosis)
                </p>
                <div class="input"></div>
            </div>
            <div>
                <p class="label">Copy to: Clinician/Practitioner</p>
                <div nz-row>
                    <div nz-col nzSpan="13">
                        <p class="label">Last Name</p>
                        <div class="input"></div>
                    </div>
                    <div nz-col nzSpan="11">
                        <p class="label">First Name</p>
                        <div class="input"></div>
                    </div>
                </div>
            </div>
            <div>
                <p class="label">Address</p>
                <div class="input"></div>
            </div>
        </div>
        <div style="flex-grow: 1; display: flex; flex-direction: column">
            <div class="info-container" style="flex-grow: 1">
                <p>Laboratory Use Only</p>
                <div>
                    <div nz-row>
                        <div nz-col nzSpan="14">
                            <p class="label">
                                Clinician/Practitioner's Contact Number for
                                Urgent Results
                            </p>
                            <div class="input">
                                {{values?.urgentContactNumber_contactNumber}}
                            </div>
                        </div>
                        <div nz-col nzSpan="10">
                            <p class="label">Service Date</p>
                            <div class="input"></div>
                        </div>
                    </div>
                    <div nz-row>
                        <div nz-col nzSpan="11">
                            <p class="label">Health Number</p>
                            <div class="input">
                                {{user?.identifiers?.[0]?.hcNum}}
                            </div>
                        </div>
                        <div nz-col nzSpan="2">
                            <p class="label">Version</p>
                            <div class="input">
                                {{user?.identifiers?.[0]?.hcVer}}
                            </div>
                        </div>
                        <div nz-col nzSpan="3">
                            <p class="label">Sex</p>
                            <div class="input">
                                {{user?.meta?.gender || (brand==='jack-health' ?
                                'Male': brand==='jill-health' ? 'Female' : '')}}
                            </div>
                        </div>
                        <div nz-col nzSpan="8">
                            <p class="label">Date of Birth</p>
                            <div class="input">{{user?.dob}}</div>
                        </div>
                    </div>
                    <div nz-row>
                        <div nz-col nzSpan="2">
                            <p class="label">Province</p>

                            <div class="input">
                                {{user?.defaultAddress?.provinceCode ?
                                user.defaultAddress.provinceCode :
                                user?.defaultAddress?.province }}
                            </div>
                        </div>
                        <div nz-col nzSpan="11">
                            <p class="label">
                                Other Provincial Registration Number
                            </p>
                            <div class="input"></div>
                        </div>
                        <div nz-col nzSpan="11">
                            <p class="label">
                                Patient's Telephone Contact Number
                            </p>
                            <div class="input">{{user?.phone}}</div>
                        </div>
                    </div>
                    <div nz-row>
                        <div nz-col nzSpan="12">
                            <p class="label">
                                Patient's Last Name (as per OHIP Card)
                            </p>

                            <div class="input">{{user?.lastName}}</div>
                        </div>
                    </div>
                    <div nz-row>
                        <div nz-col nzSpan="12">
                            <p class="label">
                                Patient's First & Middle Names (as per OHIP
                                Card)
                            </p>

                            <div class="input">{{user?.firstName}}</div>
                        </div>
                    </div>
                    <div>
                        <p class="label">
                            Patient's Address (including Postal Code)
                        </p>
                        <div class="input">
                            {{user?.defaultAddress?.address1}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div nz-row>
        <div nz-col nzSpan="10" style="display: flex; flex-direction: column">
            <my-health-input-group [title]="'Biochemistry'" testId="biochemistry" [options]="fields1" [values]="values"
                [headerStyle]="headerStyle" [inputColor]="inputColor"></my-health-input-group>
            <div class="card" style="
                    border-color: grey;
                    font-size: 14px;
                    padding: 8px;
                    flex-grow: 1;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                ">
                <p>
                    I hereby certify the tests ordered are not for registered in
                    or out patients of a hospital
                </p>
                <p *ngIf="adminUser._id === '63346d6823789c0009eef36c'">
                    Tara Long RPN JI725158, cosigner Authorized by Danny Talya
                    NP as per medical directive JJ-WL001
                </p>
                <div nz-row nzAlign="bottom">
                    <div nz-col nzSpan="15">
                        <div class="signature-container">
                            <img [src]="
                                    'assets/signatures/' +
                                    adminUser._id +
                                    '.png'
                                " />
                            <p>Clinician/Practitioner Signature</p>
                        </div>
                    </div>
                    <div nz-col nzSpan="9">
                        <div style="border-bottom: solid 1px">
                            <p style="margin-bottom: 8px">
                                {{createdAt | date: 'dd/MM/yyyy'}}
                            </p>
                        </div>
                        <p>Date</p>
                    </div>
                </div>
            </div>
        </div>
        <div nz-col nzSpan="14" style="border: solid 1px grey">
            <div nz-row>
                <div nz-col nzSpan="12">
                    <my-health-input-group [title]="'Hematology'" testId="hematology" [options]="fields21"
                        [values]="values" [headerStyle]="headerStyle" [inputColor]="inputColor"></my-health-input-group>
                    <my-health-input-group [title]="'Immunology'" testId="immunology" [options]="fields22"
                        [values]="values" [headerStyle]="headerStyle" [inputColor]="inputColor"></my-health-input-group>
                    <my-health-input-group [title]="'Microbiology ID & Sensitivities (if warranted)'"
                        testId="microbiology" [options]="fields23" [values]="values" [headerStyle]="headerStyle"
                        [inputColor]="inputColor"></my-health-input-group>
                    <div style="border: 1px solid gray">
                        <h4 [style]="headerStyle" style="padding: 10px">
                            Specimen Collection
                        </h4>
                        <div nz-row style="padding: 8px">
                            <nz-form-item>
                                <nz-form-label>Time</nz-form-label>
                                <nz-form-control nzHasFeedback>
                                    <input nz-input placeholder="24 hour clock" style="
                                            max-width: 140px;
                                            margin-right: 16px;
                                        " />
                                </nz-form-control>
                            </nz-form-item>
                            <nz-form-item>
                                <nz-form-label>Date</nz-form-label>
                                <nz-form-control nzHasFeedback>
                                    <input nz-input placeholder="yyyy/mm/dd" style="max-width: 140px" />
                                </nz-form-control>
                            </nz-form-item>
                        </div>
                    </div>
                </div>
                <div nz-col nzSpan="12">
                    <my-health-input-group [title]="'Viral Hepatitis (check one only)'" testId="viralHepatitis"
                        [options]="fields31" [values]="values" [headerStyle]="headerStyle"
                        [inputColor]="inputColor"></my-health-input-group>
                    <my-health-input-group [title]="'Prostate Specific Antigen (PSA)'" testId="psa" [options]="fields32"
                        [values]="values" [headerStyle]="headerStyle" [inputColor]="inputColor"></my-health-input-group>
                    <my-health-input-group [title]="'Vitamin D (25-Hydroxy)'" testId="vitaminD" [options]="fields33"
                        [values]="values" [headerStyle]="headerStyle" [inputColor]="inputColor"></my-health-input-group>
                    <div class="tests">
                        <h4 [style]="headerStyle" style="padding: 10px">
                            Other Tests - one test per line
                        </h4>
                        <p class="req-row" *ngFor="let v of otherTestsValues">
                            {{v}}
                        </p>
                    </div>
                </div>
            </div>
            <div>
                <h4 [style]="headerStyle" style="padding: 10px; width: 50%; margin-bottom: 0">
                    Fecal Occult Blood Test(FOBT) (check one)
                </h4>
                <div nz-row style="padding: 0 8px; border: solid 1px grey">
                    <nz-form-item style="margin-bottom: 0">
                        <nz-form-label style="order: 1" [nzNoColon]="true">FOBT (non CCC)</nz-form-label>
                        <nz-form-control nzHasFeedback style="order: 0">
                            <label class="check" nz-checkbox nzDisabled></label>
                        </nz-form-control>
                    </nz-form-item>
                    <nz-form-item style="margin-bottom: 0">
                        <nz-form-label style="order: 1" [nzNoColon]="true">ColonCancerCheck FOBT (CCC) no other test can
                            be
                            ordered on this form</nz-form-label>
                        <nz-form-control nzHasFeedback style="order: 0">
                            <label class="check" nz-checkbox nzDisabled></label>
                        </nz-form-control>
                    </nz-form-item>
                </div>

                <div style="
                        background: rgb(211, 211, 211);
                        height: 100px;
                        padding: 4px 8px;
                    ">
                    <p style="color: black; font-style: italic">
                        Laboratory Use Only
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>